/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ContratSuspensionSearchDto
 */
export interface ContratSuspensionSearchDto {
    /**
     * 
     * @type {number}
     * @memberof ContratSuspensionSearchDto
     */
    idcontrat?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContratSuspensionSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ContratSuspensionSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ContratSuspensionSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContratSuspensionSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ContratSuspensionSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ContratSuspensionSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ContratSuspensionSearchDto interface.
 */
export function instanceOfContratSuspensionSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContratSuspensionSearchDtoFromJSON(json: any): ContratSuspensionSearchDto {
    return ContratSuspensionSearchDtoFromJSONTyped(json, false);
}

export function ContratSuspensionSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContratSuspensionSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcontrat': !exists(json, 'idcontrat') ? undefined : json['idcontrat'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ContratSuspensionSearchDtoToJSON(value?: ContratSuspensionSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcontrat': value.idcontrat,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

